import { AuthenticatedTemplate, useMsal } from "@azure/msal-react";
import axios from "axios";
import { useEffect, useState } from "react";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { AuditPage } from "./pages/audit/AuditPage";
import AuditCorrelationPage from "./pages/audit/AuditCorrelationPage";
import { CalendarPage } from "./pages/calendar/calendar";
import { ConfirmationLetterPage } from "./pages/confirmationletter/ConfirmationLetter";
import { InformationPage } from "./pages/informations/InformationPage";
import { IssuePage } from "./pages/issues/issuePage";
import { QuestionPage } from "./pages/questions/questionPage";
import { ReportPageWrapper } from "./pages/report/Report";
import { Root } from "./pages/root";
import { Reports } from "./pages/root/Reports";
import { StudyPage } from "./pages/studies/studyPage";
import { TemplatePageWrapper } from "./pages/template/templatePage";
import { Login } from "./pages/user/Login";
import { NoAccess } from "./pages/user/NoAccess";
import { AccessContext, AdminOnly } from "./pages/user/accessContext";
import { fetchAccess, isBlocked } from "./api/accessApi";
import { ProtectedRoute } from "./pages/user/ProtectedRoute";
import { loginRequest } from "./pages/user/ab2cAuthProvider";
import { FollowUpLetterPage } from "./pages/followupletter/FollowUpLetter";
import { VisitPage } from "./pages/visit/VisitPage";
import { AdminPanel } from "./pages/admin/AdminPanel";
import { StatisticsPage } from "./pages/statistics/StatisticsPage";
import { SiteIssuesPage } from "./pages/siteIssues/SiteIssuesPage";
import { StudySiteIssuesPage } from "./pages/siteIssues/StudySiteIssuesPage";
import { FuturePlannedVisitsPage } from "./pages/planned-visits/FuturePlannedVisitsPage";
import { ProblemsReportPage } from "./pages/problems/ProblemsReportPage";

export const Router = () => {
  const { instance, accounts, inProgress } = useMsal();
  const [isToken, setIsToken] = useState(false);
  // Po uzyskaniu tokenu: czy konto ma dostęp (konta Scientii). Błąd (np. starszy backend bez Access/me) = bez zmian.
  const [access, setAccess] = useState(null);
  useEffect(() => {
    if (!isToken) return;
    fetchAccess().then(setAccess).catch(() => setAccess(null));
  }, [isToken]);

  useEffect(() => {
    let t = async () => {
      try {
        const token = await instance.acquireTokenSilent(loginRequest);
        localStorage.setItem("webApiAccessToken", token.accessToken);

        axios.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${token.accessToken}`;
        setIsToken(true);
      } catch (err) {
        if (err.errorMessage.includes("AADB2C90077")) {
          instance.loginRedirect();
        }
      }
    };
    if (
      accounts[0] &&
      inProgress != "startup" &&
      instance?.getActiveAccount() &&
      !isToken
    ) {
      t();
    }
  }, [instance, inProgress]);

  const routesForAuthenticatedOnly = [
    {
      element: <ProtectedRoute />, // Wrap the component in ProtectedRoute
      children: [
        {
          path: "/",
          element: <Root />,
        },
        {
          path: "/reports/",
          element: <Reports />,
        },
        {
          path: "/reports/:reportId",
          element: <ReportPageWrapper />,
        },
        {
          path: "/study/:studyId",
          element: <StudyPage />,
        },
        {
          path: "/templates/:templateId",
          element: <TemplatePageWrapper />,
        },
        {
          path: "/confirmationletter/:letterId",
          element: <ConfirmationLetterPage />,
        },
        {
          path: "/followupletter/:letterId",
          element: <FollowUpLetterPage />,
        },
        {
          path: "/questions/:questionId",
          element: <AdminOnly><QuestionPage /></AdminOnly>,
        },
        { path: "/admin", element: <AdminOnly><AdminPanel /></AdminOnly> },
        { path: "/statistics", element: <StatisticsPage /> },
        {
          path: "/issues/:categoryId",
          element: <AdminOnly><IssuePage /></AdminOnly>,
        },
        {
          path: "/information",
          element: <InformationPage />,
        },
        {
          path: "/audit",
          element: <AuditPage />,
        },
        {
          path: "/audit/correlation/:id",
          element: <AuditCorrelationPage />,
        },
        {
          path: "/calendar",
          element: <CalendarPage />,
        },
        {
          path: "/visit/:visitId",
          element: <VisitPage />,
        },
        {
          path: "/resorts/:resortId/issues",
          element: <SiteIssuesPage />,
        },
        {
          path: "/study/:studyId/issues",
          element: <StudySiteIssuesPage />,
        },
        {
          path: "/planned-visits",
          element: <FuturePlannedVisitsPage />,
        },
        {
          path: "/problems",
          element: <ProblemsReportPage />,
        },
      ],
    },
  ];

  const router = createBrowserRouter([...routesForAuthenticatedOnly]);
  const acc = instance.getActiveAccount();
  return (
    <>
      {acc && isBlocked(access) ? (
        <NoAccess email={access.email} />
      ) : acc ? (
        <AuthenticatedTemplate>
          <AccessContext.Provider value={access}>
            <RouterProvider router={router} />{" "}
          </AccessContext.Provider>
        </AuthenticatedTemplate>
      ) : (
        <Login />
      )}
    </>
  );
};
